import { render } from "./navbar.vue?vue&type=template&id=0c037ab7&scoped=true&ts=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"

import "./navbar.vue?vue&type=style&index=0&id=0c037ab7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c037ab7"]])

export default __exports__